const MoneyMgmtTestTopicList = [
    {testTopic: "Budgeting & Saving", nbrQuestions: 2, abbrev: "BD", sortOrder: 2},
    {testTopic: "Credit & Debt", nbrQuestions: 2, abbrev: "CD", sortOrder: 3},
    {testTopic: "Career & Income Planning", nbrQuestions: 1, abbrev: "CI", sortOrder: 5},
    {testTopic: "Investing & Wealth Building", nbrQuestions: 2, abbrev: "IW", sortOrder: 4},
    {testTopic: "Financial Decision-Making", nbrQuestions: 1, abbrev: "FD", sortOrder: 6},
    {testTopic: "Risk Management & Insurance", nbrQuestions: 1, abbrev: "RI", sortOrder: 7},
    {testTopic: "General Financial Literacy", nbrQuestions: 1, abbrev: "GN", sortOrder: 1},
    
]

export default MoneyMgmtTestTopicList;